import React from 'react';
import { Link } from 'react-router-dom';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
    return (
        <div className="terms-container">
            <div className="terms-content">
                <div className="terms-header">
                    <h1>Terms and Conditions</h1>
                    <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
                </div>

                <div className="terms-body">
                    <section className="terms-section">
                        <h2>1. Acceptance of Terms</h2>
                        <p>
                            By accessing and using WhatToMake.co.za ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>2. User-Generated Content License</h2>
                        <p>
                            By creating, uploading, posting, or sharing any content on our platform (including but not limited to recipes, images, comments, reviews, and other materials), you grant WhatToMake.co.za a non-exclusive, royalty-free, worldwide, perpetual, and irrevocable license to:
                        </p>
                        <ul>
                            <li>Use, reproduce, modify, adapt, and distribute your content</li>
                            <li>Display your content on our platform and in our marketing materials</li>
                            <li>Create derivative works based on your content</li>
                            <li>Share your content with other users of the platform</li>
                            <li>Use your content for promotional and advertising purposes</li>
                            <li>Analyze your content to improve our services and user experience</li>
                        </ul>
                        <p>
                            You retain ownership of your content, but by posting it on our platform, you grant us these rights to use it as described above.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>3. Content Guidelines and Prohibited Uses</h2>
                        <p>You agree not to post content that:</p>
                        <ul>
                            <li>Is illegal, harmful, threatening, abusive, or defamatory</li>
                            <li>Infringes on intellectual property rights of others</li>
                            <li>Contains viruses, malware, or other harmful code</li>
                            <li>Is spam, promotional material, or commercial content without permission</li>
                            <li>Violates any applicable laws or regulations</li>
                            <li>Contains personal information of others without consent</li>
                        </ul>
                    </section>

                    <section className="terms-section">
                        <h2>4. Privacy and Data Protection</h2>
                        <p>
                            We are committed to protecting your privacy and personal information. By using our service, you consent to our data practices as outlined below:
                        </p>
                        <h3>4.1 Data Collection</h3>
                        <p>We collect the following types of information:</p>
                        <ul>
                            <li>Personal information (name, email address) for account management</li>
                            <li>Recipe data and cooking preferences to provide personalized services</li>
                            <li>Usage analytics to improve our platform functionality</li>
                            <li>Payment information (processed securely through third-party payment processors)</li>
                        </ul>
                        
                        <h3>4.2 Data Protection Commitment</h3>
                        <p><strong>We will NEVER sell your personal data to third parties.</strong> Your personal information, including but not limited to your name, email address, and any other identifying information, will not be sold, rented, or shared with third-party companies for marketing or commercial purposes.</p>
                        
                        <h3>4.3 Data Usage</h3>
                        <p>We use your data solely for the following purposes:</p>
                        <ul>
                            <li>Providing and improving our recipe and cooking services</li>
                            <li>Account management and customer support</li>
                            <li>Personalized recipe recommendations</li>
                            <li>Platform analytics and service optimization</li>
                            <li>Legal compliance and fraud prevention</li>
                        </ul>
                        
                        <h3>4.4 Data Security</h3>
                        <p>We implement industry-standard security measures to protect your personal information, including encryption, secure servers, and regular security audits.</p>
                    </section>

                    <section className="terms-section">
                        <h2>5. Payment Terms and Security</h2>
                        <p>
                            When you make payments through our platform, we ensure the highest level of security and protection for your financial information.
                        </p>
                        <h3>5.1 Payment Processing</h3>
                        <p>All payments are processed through secure, PCI DSS compliant third-party payment processors. We do not store your complete payment card information on our servers.</p>
                        
                        <h3>5.2 Payment Data Security</h3>
                        <p>Your payment data is protected through:</p>
                        <ul>
                            <li>End-to-end encryption during transmission</li>
                            <li>Secure tokenization of payment information</li>
                            <li>PCI DSS compliant payment processors</li>
                            <li>Regular security audits and monitoring</li>
                            <li>Fraud detection and prevention systems</li>
                        </ul>
                        
                        <h3>5.3 Payment Information Handling</h3>
                        <p>We will never:</p>
                        <ul>
                            <li>Store your complete credit card numbers on our servers</li>
                            <li>Share your payment information with unauthorized parties</li>
                            <li>Use your payment data for purposes other than processing your transactions</li>
                            <li>Sell or rent your payment information to third parties</li>
                        </ul>
                        
                        <h3>5.4 Billing and Refunds</h3>
                        <p>All billing disputes and refund requests should be directed to our customer support team. We will process legitimate refund requests in accordance with our refund policy.</p>
                    </section>

                    <section className="terms-section">
                        <h2>6. Account Responsibilities</h2>
                        <p>You are responsible for:</p>
                        <ul>
                            <li>Maintaining the confidentiality of your account credentials</li>
                            <li>All activities that occur under your account</li>
                            <li>Ensuring your content does not violate these terms</li>
                            <li>Providing accurate and up-to-date information</li>
                        </ul>
                    </section>

                    <section className="terms-section">
                        <h2>7. Intellectual Property Rights</h2>
                        <p>
                            The Service and its original content, features, and functionality are and will remain the exclusive property of WhatToMake.co.za and its licensors. The Service is protected by copyright, trademark, and other laws.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>8. Termination</h2>
                        <p>
                            We may terminate or suspend your account and bar access to the Service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever, including but not limited to a breach of the Terms.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>9. Disclaimer and Limitation of Liability</h2>
                        <p>
                            The information on this Service is provided on an "as is" basis. To the fullest extent permitted by law, WhatToMake.co.za excludes all representations, warranties, conditions and terms relating to our Service and the use of this Service.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>10. Changes to Terms</h2>
                        <p>
                            We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days notice prior to any new terms taking effect.
                        </p>
                    </section>

                    <section className="terms-section">
                        <h2>11. Contact Information</h2>
                        <p>
                            If you have any questions about these Terms and Conditions, please contact us at:
                        </p>
                        <p>
                            Email: higgos@whattomake.co.za<br />
                            Website: https://whattomake.co.za
                        </p>
                    </section>
                </div>

                <div className="terms-footer">
                    <Link to="/auth/register" className="back-to-register">
                        ← Back to Registration
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;
